

















































import { Component, Model, Vue } from "vue-property-decorator";
import { VesselGroup } from "@/types/vesselGroup";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import VesselGroupsModule from "@/store/clients/VesselGroups.module";
import CreateVesselGroupDialog from "./CreateVesselGroupDialog.vue";
import DfiSelectMultiple from "../DfiForm/DfiSelectMultiple.vue";

const VesselGroups = getModule(VesselGroupsModule, store);

@Component({
  components: {
    CreateVesselGroupDialog,
    DfiSelectMultiple,
  }
})
export default class VesselGroupFilter extends Vue {
  @Model("update:modelValue") groups!: number[];
  
  isDialogVisible: boolean = false;

  get selectedGroupIds(): VesselGroup[] {
    return this.vesselGroups.filter(g => this.groups.includes(g.id));
  }

  get vesselGroups(): VesselGroup[] {
    return VesselGroups.vesselGroups;
  }
  
  valueFormatter(selected: number) {
    if (selected === 0) return "";

    if (selected === this.vesselGroups.length) return "All Vessel Groups selected"

    return `${selected} Vessel Group${selected > 1 ? "s" : ""} selected`
  }

  onGroupAdded() {
    this.isDialogVisible = false;
    VesselGroups.EXPIRE_DATA();
    VesselGroups.getAll();
  }

  onGroupChange(groups: VesselGroup[]) {
    this.$emit("update:modelValue", groups.map((group: VesselGroup) => group.id));
  }

  openCreateDialog(): void {
    this.isDialogVisible = true;
  }
}
